import PropertyItemComponent from "../components/property-component";
import UlComponent from "../components/ul";
import {isEmptyArray} from "../utils/is-empty-array";
import {RenderPosition, render} from "../utils/render";

export default class PropertiesController {
  constructor({properties = 0}) {
    this._properties = properties;
  }

  render(container) {
    if (isEmptyArray(this._properties)) {
      return;
    }

    const listComponent = new UlComponent(`product-list__itemPropertyList`);
    render(container, listComponent.getElement(), RenderPosition.BEFOREEND);

    this._properties.forEach((property) => {
      const labelComponent = new PropertyItemComponent({property});
      render(listComponent.getElement(), labelComponent.getElement(), RenderPosition.BEFOREEND);
    });
  }
}
